// Dependencies
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
// Core & Lab
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
// Icons
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import { mapKeys, mapValues } from 'lodash';
// Components
import CircuitNameLocale from './circuitNameLocale';
import LocaleSelector from '../locale/localeSelector';
import LocaleAutoTranslate from '../locale/localeAutoTranslate';
// Utils
import LightTooltip from '../utils/tooltip/lightTooltip';
// Actions
import { updateCircuitNameLocale, updateCircuitNameLocales } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { Circuit } from './objects/circuit';

type Props = {
    circuit: Circuit | null
}

export function CircuitName(props: Props): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const circuit_name_locales = useSelector((state: AppState) => state.circuit.circuit_name_locales);

    // recreate inputs
    // useEffect(() => {
    //     if (props.circuit) {
    //         dispatch(
    //             updateCircuitNameLocales(
    //                 mapValues(
    //                     mapKeys(
    //                         props.circuit.localization,
    //                         (item) => item.locale
    //                     ),
    //                     (value) => value.name ?? ''
    //                 )
    //             )
    //         );
    //     }
    // }, [props.circuit]);

    return (
        <Grid item xs={ 12 }>
            <Accordion defaultExpanded>
                <AccordionSummary>
                    <Typography>{ t('shared.circuit-name-translations') }<LightTooltip title={ t('shared.circuit-name-translations-helper') }><HelpOutlineOutlined className={ 'ft-role-info' }/></LightTooltip></Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={ 2 }>
                        <Grid item xs={ 6 }>
                            <LocaleSelector id={ 'circuit-name' } values={ circuit_name_locales }/>
                        </Grid>
                        <Grid item xs={ 12 }>
                            <CircuitNameLocale/>
                        </Grid>
                        <Grid item xs={ 12 }>
                            <LocaleAutoTranslate id={ 'circuit-name' } values={ circuit_name_locales } action={ updateCircuitNameLocale }/>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
}